import React from "react"
import { FaEye } from "react-icons/fa"
import { type Props } from "./_types"
const IconView: React.FC<Props> = ({ size = 15, color = "#fff" }): React.ReactElement => {
  return <FaEye size={size} color={color} />
}

export default IconView
